import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import JobIcon from '../assets/images/job.svg'
import LocationIcon from '../assets/images/map-point.svg'
import CalendarIcon from '../assets/images/calendar.svg'
import ArrowRight2 from '../assets/images/button-arrow.svg'
import ExperienceIcon from '../assets/images/career/1.svg'
import WorkingHoursIcon from '../assets/images/career/2.svg'
import WorkingDayscon from '../assets/images/career/3.svg'
import SalaryIcon from '../assets/images/career/4.svg'
import VacancyIcon from '../assets/images/career/5.svg'
import DeadlineIcon from '../assets/images/career/6.svg'
import { useLocation } from "react-router-dom";
import { formatDateTime } from '../utils/date';


const CareerInfo = () => {
  const location = useLocation();
  const [selectedJob, setSelectedJob] = React.useState(location.state);

  const handleApplyClick = () => {
    setSelectedJob(location.state); // store the job
    document.getElementById("CareerForm")?.scrollIntoView({ behavior: "smooth" });
  };

  const sidebar = [
    { label: "Experience", value: `${location?.state?.experience} Years Experience`, img: ExperienceIcon },
    { label: "Working Hours", value: `${location?.state?.working_hours}`, img: WorkingHoursIcon },
    { label: "Working Days", value: `${location?.state?.working_days}`, img: WorkingDayscon },
    { label: "Salary", value: `${location?.state?.salary}`, img: SalaryIcon },
    { label: "Vacancy", value: `No of Vacancies: ${location?.state?.no_of_vacancies}`, img: VacancyIcon },
    { label: "Deadline", value: `${formatDateTime(location?.state?.deadline)}`, img: DeadlineIcon }
  ];
  return (
    <section className="career-details-section common-padding">
      <Container>
        <Row>
          {/* Main Content */}
          <Col md={12}>
            <div className="job-card">
              <div className="job-info">
                <h3 className="job-title">{location.state?.job_title}</h3>
                <div className="job-meta">
                  <div className="meta-item">
                    <div className="icon-wrapper briefcase">
                      <img src={JobIcon} alt="Job Type" />
                    </div>
                    <div>
                      <span className="meta-label">Job Type</span>
                      <span className="meta-value">{location.state?.job_type}</span>
                    </div>
                  </div>
                  <div className="meta-item">
                    <div className="icon-wrapper location">
                      <img src={LocationIcon} alt="Location" />
                    </div>
                    <div>
                      <span className="meta-label">Location</span>
                      <span className="meta-value">{location.state?.location}</span>
                    </div>
                  </div>
                  <div className="meta-item">
                    <div className="icon-wrapper location">
                      <img src={CalendarIcon} alt="Location" />
                    </div>
                    <div>
                      <span className="meta-label">Date</span>
                      <span className="meta-value">{formatDateTime(location.state?.created_at)}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="job-action">

                <button
                  onClick={handleApplyClick}
                  className="custom-bttn style-3 primary ani-1"
                >
                  Apply Now
                  <img src={ArrowRight2} alt="Arrow Right" />
                </button>

              </div>
            </div>
          </Col>
          <Col lg={8} md={12}>
            <div className="job-details-content">
              <div className="job-section">
                <ul
                  className="responsibilities-list"
                  dangerouslySetInnerHTML={{ __html: location.state?.job_description || "" }}
                ></ul>

              </div>

              {/* Apply Button */}
              <div className="apply-section">
                <button
                  onClick={handleApplyClick}
                  className="custom-bttn ani-1"
                >
                  Apply Now
                  <img src={ArrowRight2} alt="Arrow Right" />
                </button>
              </div>
            </div>
          </Col>

          {/* Sidebar */}
          <Col lg={4} md={12}>
            <div className="job-sidebar">
              <div className="sidebar-card">
                <ul className="sidebar-list">
                  {sidebar.map((item, index) => (
                    <li key={index} className="sidebar-item">
                      <div className="icon-wrapper">
                        <img src={item.img} alt={item.label} />
                      </div>
                      <div className="item-content">
                        <span className="label">{item.label}</span>
                        <span className="value">{item.value}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CareerInfo;
